
import AboutUs from "../Pages/mainPage/About/AboutUs";
import ContactUs from "../Pages/mainPage/Contact/ContactUs";
import FAQ from "../Pages/mainPage/FAQ";
import HDRF from "../Pages/mainPage/HDRF/HDRF";
import Home from "../Pages/mainPage/Home/Home";
import Outsourcing from "../Pages/mainPage/Outsourcing/Outsourcing";
import PrivacyPolicy from "../Pages/mainPage/PrivacyPolicy";
import CommonPage from "../Pages/mainPage/Products/CommonPage";
import E_Form from "../Pages/mainPage/Products/e-Form/E_Form";
import EAM from "../Pages/mainPage/Products/EAM/EAM";
import IPB from "../Pages/mainPage/Products/IPB/IPB";
import OJT from "../Pages/mainPage/Products/OJT/OJT";
import PTW from "../Pages/mainPage/Products/PTW/PTW";
import SafetyWalk from "../Pages/mainPage/Products/SafetyWalk/SafetyWalk";
import CyberSecurity from "../Pages/mainPage/Service/CyberSecurity";
import Oracle from "../Pages/mainPage/Service/Oracle";
import Saleforce from "../Pages/mainPage/Service/Saleforce";
import Service from "../Pages/mainPage/Service/Service";
import SharePoint from "../Pages/mainPage/Service/SharePoint";
import TestAutomation from "../Pages/mainPage/Service/TestAutomation";
import Terms from "../Pages/mainPage/Terms";

export const routerLink = [
  {
    path: "/",
    component: Home,
    metaTag:{
      title:"Solver Thoughts Technologies | EAM, CMMS & Enterprise Software Solutions",
      description:"Solver Thoughts Technologies delivers Enterprise Asset Management (EAM), CMMS, safety, and custom enterprise software solutions for manufacturing, oil & gas, healthcare, power plants, and utilities.",
      keyword:"Solver Thoughts Technologies, Enterprise Asset Management, EAM, CMMS, Asset Management, Computerised Maintenance Management System, Maintenance Software, Asset Lifecycle, Preventive Maintenance, Oil & Gas Asset Management, Manufacturing Maintenance, Healthcare CMMS, Utility Asset Tracking, Power Plant",
      canonical:true,
      canonicalLink:"https://www.solverthoughts.com/",
      ogTitle:"Solver Thoughts Technologies | EAM, CMMS & Enterprise Software Solutions",
      ogDescription:"Empower your operations with scalable EAM and CMMS systems. Trusted by leaders in manufacturing, energy, and healthcare.",
      ogUrl:"https://www.solverthoughts.com/",
      ogImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      twitterCard:"summary_large_image",
      twitterTitle:"Solver Thoughts Technologies | EAM & CMMS for Manufacturing, Oil & Gas, Healthcare",
      twitterDescription:"Streamline asset and maintenance management with Solver Thoughts' industry-focused EAM & CMMS platform.",
      twitterImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      script:false,
    },

  },
  {
    path: "/aboutus",
    component: AboutUs,
    metaTag:{
      title:"About Us | Solver Thoughts Technologies",
      description:"Learn about Solver Thoughts Technologies — our mission and the team behind our EAM, CMMS, safety, and enterprise software solutions serving industries worldwide.",
      keyword:"About Solver Thoughts Technologies, company profile, enterprise software company, EAM CMMS provider, IT solutions company Malaysia",
      canonical:true,
      canonicalLink:"https://www.solverthoughts.com/aboutus",
      ogTitle:"About Us | Solver Thoughts Technologies",
      ogDescription:"Learn about Solver Thoughts Technologies — our mission and the team behind our EAM, CMMS, safety, and enterprise software solutions serving industries worldwide.",
      ogUrl:"https://www.solverthoughts.com/aboutus",
      ogImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      twitterCard:"summary_large_image",
      twitterTitle:"About Us | Solver Thoughts Technologies",
      twitterDescription:"Learn about Solver Thoughts Technologies — our mission and the team behind our EAM, CMMS, safety, and enterprise software solutions serving industries worldwide.",
      twitterImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      script:false,
    },

  },
  
  {
    path: "/products",
    component: CommonPage,
    metaTag:{
      title:"Our Products | EAM, CMMS, Safety Walk, PTW & More | Solver Thoughts Technologies",
      description:"Explore Solver Thoughts Technologies' full product suite — Enterprise Asset Management (EAM), CMMS, Safety Walk, Permit to Work (PTW), Security e-Form, OJT, and Internet Booking Platform.",
      keyword:"Solver Thoughts products, Enterprise Asset Management, EAM, CMMS, Safety Walk, Permit to Work, PTW, e-Form, OJT, Internet Booking Platform, Asset Management Software",
      canonical:true,
      canonicalLink:"https://www.solverthoughts.com/products",
      ogTitle:"Our Products | EAM, CMMS, Safety Walk, PTW & More | Solver Thoughts Technologies",
      ogDescription:"Explore Solver Thoughts Technologies' full product suite — Enterprise Asset Management (EAM), CMMS, Safety Walk, Permit to Work (PTW), Security e-Form, OJT, and Internet Booking Platform.",
      ogUrl:"https://www.solverthoughts.com/products",
      ogImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      twitterCard:"summary_large_image",
      twitterTitle:"Our Products | Solver Thoughts Technologies",
      twitterDescription:"Explore Solver Thoughts Technologies' full product suite — EAM, CMMS, Safety Walk, PTW, e-Form, OJT, and Internet Booking Platform.",
      twitterImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      script:false,
    },

  },
  {
    path: "/products/safetywalk",
    component: SafetyWalk,
    metaTag:{
      title:"Safety Walk",
      description:"Solverthoughts' Safety Walk: Digitally report safety findings, route approvals, & track tasks. Enhances compliance & reduces paperwork for diverse industries.",
      keyword:"safety walk software, safety findings reporting, digital safety inspections, EHS software, workplace safety, safety compliance, Oil & Gas, Manufacturing, Construction, Chemical, Petrochemical, Mining, Utilities, Pharmaceuticals, Shipbuilding, Marine, Power Generation, Facilities Management, Transportation, Logistics, Food & Beverage, Aerospace, Aviation, Railways, Metro, Renewable Energy",
      canonical:true,
      canonicalLink:"https://www.solverthoughts.com/products",
      ogTitle:"Safety Walk",
      ogDescription:"Solverthoughts' Safety Walk: Digitally report safety findings, route approvals, & track tasks. Enhances compliance & reduces paperwork for diverse industries.",
      ogUrl:"https://www.solverthoughts.com/products/eam",
      ogImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      twitterCard:"summary_large_image",
      twitterTitle:"Safety Walk",
      twitterDescription:"Solverthoughts' Safety Walk: Digitally report safety findings, route approvals, & track tasks. Enhances compliance & reduces paperwork for diverse industries.",
      twitterImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      script:true,
      scriptData:{
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "Solverthoughts Safety Walk",
        "description": "Digitally report safety findings with image attachments, route for approvals, and track tasks to enhance workplace safety and compliance. Features include historical e-Forms and interactive dashboards.",
        "applicationCategory": "Business",
        "featureList": [
          "Digital Safety Findings Reporting",
          "Multiple Approval Routing",
          "Image Attachment for Findings",
          "Task Tracking and Alerts",
          "Historical Safety e-Forms Access",
          "Interactive Dashboards & KPIs"
        ],
        "areaServed": [
          "Oil & Gas Industry",
          "Manufacturing Industry",
          "Construction Industry",
          "Chemical & Petrochemical Industry",
          "Mining Industry",
          "Utilities (Electricity, Water, Gas) Industry",
          "Pharmaceuticals Industry",
          "Shipbuilding & Marine Industry",
          "Power Generation (Thermal, Nuclear, Renewable) Industry",
          "Facilities Management (Hospitals, Airports, Malls, Data Centers) Industry",
          "Transportation & Logistics Industry",
          "Food & Beverage Processing Industry",
          "Aerospace & Aviation Maintenance Industry",
          "Railways & Metro Systems Industry",
          "Renewable Energy (Solar, Wind) Industry"
        ]
      }
        
    },
  },
  {
    path: "/products/e_form",
    component: E_Form,
    metaTag:{
      title:"Security e-Form | Digital Form Management | Solver Thoughts Technologies",
      description:"Digitize form submission and approval workflows with Solverthoughts' Security e-Form — real-time tracking, secure data capture, and paperless processing for enterprises.",
      keyword:"e-Form software, digital form submission, Security e-Form, paperless forms, workflow automation, form tracking software",
      canonical:true,
      canonicalLink:"https://www.solverthoughts.com/products/e_form",
      ogTitle:"Security e-Form | Solver Thoughts Technologies",
      ogDescription:"Digitize form submission and approval workflows with Solverthoughts' Security e-Form — real-time tracking, secure data capture, and paperless processing.",
      ogUrl:"https://www.solverthoughts.com/products/e_form",
      ogImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      twitterCard:"summary_large_image",
      twitterTitle:"Security e-Form | Solver Thoughts Technologies",
      twitterDescription:"Digitize form submission and approval workflows with Solverthoughts' Security e-Form — real-time tracking, secure data capture, and paperless processing.",
      twitterImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      script:false,
    },
  },
  {
    path: "/products/ptw",
    component: PTW,
    metaTag:{
      title:"Permit To Work (PTW)",
      description:"Streamline high-risk work with our Permit to Work (PTW) software. Enhance safety & compliance for Oil & Gas, Construction, Manufacturing, Utilities, and more.",
      keyword:"Permit to Work software, PTW system, digital permit, electronic PTW, work permit, safety compliance, Oil and Gas, Construction, Manufacturing, Utilities, Energy, Chemical, Transportation, Healthcare, Facilities Management, Mining",
      canonical:true,
      canonicalLink:"https://www.solverthoughts.com/products",
      ogTitle:"Permit To Work (PTW)",
      ogDescription:"Streamline high-risk work with our Permit to Work (PTW) software. Enhance safety & compliance for Oil & Gas, Construction, Manufacturing, Utilities, and more.",
      ogUrl:"https://www.solverthoughts.com/products/eam",
      ogImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      twitterCard:"summary_large_image",
      twitterTitle:"Permit To Work (PTW)",
      twitterDescription:"Streamline high-risk work with our Permit to Work (PTW) software. Enhance safety & compliance for Oil & Gas, Construction, Manufacturing, Utilities, and more.",
      twitterImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      script:true,
      scriptData: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "Permit to Work (PTW) Software",
        "description": "Software solution for managing and controlling high-risk work activities through digital permits, enhancing safety, compliance, and operational efficiency.",
        "applicationCategory": "Business",
        "featureList": [
          "Digital Permit Creation and Management",
          "Risk Assessment Integration",
          "Workflow Automation",
          "Electronic Signatures",
          "Real-time Tracking and Monitoring",
          "Compliance Management",
          "Reporting and Analytics",
          "Mobile Access"
        ],
        "areaServed": [
          "Oil and Gas Industry",
          "Construction Industry",
          "Manufacturing Industry",
          "Utilities and Energy Industry",
          "Chemical Industry",
          "Transportation Industry",
          "Healthcare Industry",
          "Facilities Management Industry",
          "Mining Industry"
        ],
      "product": [
      {
        "@type": "Product",
        "name": "Permit to Work Software"
      },
      {
        "@type": "Product",
        "name": "Digital Permit to Work System"
      },
      {
        "@type": "Product",
        "name": "Electronic Permit to Work (ePTW)"
      },
      {
        "@type": "Product",
        "name": "Work Permit Software"
      },
      {
        "@type": "Product",
        "name": "Online Permit to Work"
      }
    ]
  }

    },
  },
  {
    path: "/products/eam",
    component: EAM,
    metaTag:{
      title:"Enterprise Asset Management (EAM) & CMMS | Solver Thoughts Technologies",
      description:"SolverThoughts offers advanced EAM, CMMS, and asset tracking software for manufacturing, healthcare, utilities, construction, transport, and facilities.",
      keyword:"Enterprise Asset Management Software, CMMS, Asset Tracking Software, Preventive Maintenance, Work Order Management, Predictive Maintenance, IoT EAM, Cloud EAM, SAP EAM, Manufacturing, Construction, Transportation, Healthcare, Facilities Management, Utilities, Energy, power plant ",
      canonical:true,
      canonicalLink:"https://www.solverthoughts.com/products",
      ogTitle:"EAM & CMMS Solutions for Industry Leaders | Solver Thoughts Technologies",
      ogDescription:"SolverThoughts offers advanced EAM, CMMS, and asset tracking software for manufacturing, healthcare, utilities, construction, transport, and facilities.",
      ogUrl:"https://www.solverthoughts.com/products/eam",
      ogImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      twitterCard:"summary_large_image",
      twitterTitle:"Solver Thoughts Technologies | EAM & CMMS for Manufacturing, Oil & Gas, Healthcare",
      twitterDescription:"SolverThoughts offers advanced EAM, CMMS, and asset tracking software for manufacturing, healthcare, utilities, construction, transport, and facilities.",
      twitterImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      script:true,
      scriptData:{
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "SolverThoughts",
        "url": "https://www.solverthoughts.com",
        "description": "SolverThoughts delivers top-tier Enterprise Asset Management (EAM), CMMS, and predictive maintenance software solutions across various industries.",
        "sameAs": [
          "https://www.linkedin.com/company/solverthoughts",
          "https://twitter.com/solverthoughts"
        ],
        "product": [
          {
            "@type": "Product",
            "name": "Enterprise Asset Management Software",
            "category": "Software"
          },
          {
            "@type": "Product",
            "name": "Asset Tracking Software",
            "category": "Software"
          },
          {
            "@type": "Product",
            "name": "Preventive Maintenance Software",
            "category": "Software"
          },
          {
            "@type": "Product",
            "name": "Work Order Management Software",
            "category": "Software"
          },
          {
            "@type": "Product",
            "name": "CMMS (Computerized Maintenance Management System)",
            "category": "Software"
          },
          {
            "@type": "Product",
            "name": "Asset Performance Management",
            "category": "Software"
          },
          {
            "@type": "Product",
            "name": "IoT-enabled EAM",
            "category": "Software"
          },
          {
            "@type": "Product",
            "name": "Cloud-based EAM Solutions",
            "category": "Software"
          },
          {
            "@type": "Product",
            "name": "Predictive Maintenance Software",
            "category": "Software"
          },
          {
            "@type": "Product",
            "name": "SAP EAM",
            "category": "Software"
          }
        ],
        "areaServed": [
          {
            "@type": "Industry",
            "name": "Manufacturing"
          },
          {
            "@type": "Industry",
            "name": "Construction"
          },
          {
            "@type": "Industry",
            "name": "Transportation"
          },
          {
            "@type": "Industry",
            "name": "Healthcare"
          },
          {
            "@type": "Industry",
            "name": "Facilities Management"
          },
          {
            "@type": "Industry",
            "name": "Utilities and Energy"
          }
        ]
      }
      
    },
  },
  {
    path: "/products/ojt",
    component: OJT,
    metaTag:{
      title:"Online Job Training (OJT) | Employee Training Management | Solver Thoughts Technologies",
      description:"Streamline employee training programs with Solverthoughts' OJT platform — track progress, manage trainers, and boost workforce efficiency and growth.",
      keyword:"Online Job Training software, OJT platform, employee training management, workforce training tracking, training management system",
      canonical:true,
      canonicalLink:"https://www.solverthoughts.com/products/ojt",
      ogTitle:"Online Job Training (OJT) | Solver Thoughts Technologies",
      ogDescription:"Streamline employee training programs with Solverthoughts' OJT platform — track progress, manage trainers, and boost workforce efficiency.",
      ogUrl:"https://www.solverthoughts.com/products/ojt",
      ogImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      twitterCard:"summary_large_image",
      twitterTitle:"Online Job Training (OJT) | Solver Thoughts Technologies",
      twitterDescription:"Streamline employee training programs with Solverthoughts' OJT platform — track progress, manage trainers, and boost workforce efficiency.",
      twitterImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      script:false,
    },
  },
  {
    path: "/products/ipb",
    component: IPB,
    metaTag:{
      title:"Internet Booking Platform (IPB) | Solver Thoughts Technologies",
      description:"Solverthoughts' Internet Booking Platform (IPB) simplifies online booking and reservation management with a secure, scalable digital platform.",
      keyword:"Internet Booking Platform, IPB software, online booking system, reservation management software",
      canonical:true,
      canonicalLink:"https://www.solverthoughts.com/products/ipb",
      ogTitle:"Internet Booking Platform (IPB) | Solver Thoughts Technologies",
      ogDescription:"Solverthoughts' Internet Booking Platform (IPB) simplifies online booking and reservation management with a secure, scalable digital platform.",
      ogUrl:"https://www.solverthoughts.com/products/ipb",
      ogImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      twitterCard:"summary_large_image",
      twitterTitle:"Internet Booking Platform (IPB) | Solver Thoughts Technologies",
      twitterDescription:"Solverthoughts' Internet Booking Platform (IPB) simplifies online booking and reservation management with a secure, scalable digital platform.",
      twitterImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      script:false,
    },
  },
  {
    path: "/services",
    component: Service,
    metaTag:{
      title:"Custom Solution",
      description:"SolverThoughts provides Digital Transformation, Enterprise Solutions, Custom Web & Mobile Apps, Cloud Development, SaaS, ECommerce, and more tailored services.",
      keyword:"Digital Transformation, Digitalization, Enterprise Solutions, Web & Mobile Solutions, Custom Apps, ECommerce Apps, Enterprise Cloud Development, SaaS, Cloud Integration, Cloud Optimization, SaaS for Startups, SaaS for Enterprises, Integration, Upgrade, Maintenance, Custom Web Development, Mobile Solutions",
      canonical:false,
      // canonicalLink:"https://www.solverthoughts.com/products",
      ogTitle:"Custom Solution",
      ogDescription:"SolverThoughts provides Digital Transformation, Enterprise Solutions, Custom Web & Mobile Apps, Cloud Development, SaaS, ECommerce, and more tailored services.",
      ogUrl:"https://www.solverthoughts.com/services",
      ogImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      twitterCard:"summary_large_image",
      twitterTitle:"Custom Solution",
      twitterDescription:"SolverThoughts provides Digital Transformation, Enterprise Solutions, Custom Web & Mobile Apps, Cloud Development, SaaS, ECommerce, and more tailored services.",
      twitterImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      script:true,
      scriptData:{
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "SolverThoughts",
        "url": "https://www.solverthoughts.com",
        "description": "SolverThoughts provides Digital Transformation, Enterprise Solutions, Custom Web & Mobile Apps, Cloud Development, SaaS, ECommerce, and more tailored services.",
        "serviceType": [
          {
            "@type": "Service",
            "name": "Digital Transformation",
            "description": "Helping businesses leverage digital technologies to transform their processes and enhance customer experiences."
          },
          {
            "@type": "Service",
            "name": "Digitalization",
            "description": "Digitizing business operations for improved efficiency and enhanced productivity through cutting-edge solutions."
          },
          {
            "@type": "Service",
            "name": "Enterprise Solutions",
            "description": "Enterprise-level solutions to optimize business functions and improve organizational performance."
          },
          {
            "@type": "Service",
            "name": "Upgrade",
            "description": "Upgrading legacy systems and software to modern, efficient solutions that support business growth."
          },
          {
            "@type": "Service",
            "name": "Web & Mobile Solutions",
            "description": "Custom web and mobile app development to meet the unique needs of your business and users."
          },
          {
            "@type": "Service",
            "name": "Maintenance",
            "description": "Ongoing support and maintenance services to keep your systems running smoothly and securely."
          },
          {
            "@type": "Service",
            "name": "Custom Web & Mobile Apps",
            "description": "Design and development of custom web and mobile applications tailored to your business requirements."
          },
          {
            "@type": "Service",
            "name": "Enterprise Mobility",
            "description": "Enterprise mobility solutions that enable employees to access systems and data remotely and securely."
          },
          {
            "@type": "Service",
            "name": "ECommerce Apps",
            "description": "Development of custom eCommerce applications for a seamless and engaging shopping experience."
          },
          {
            "@type": "Service",
            "name": "Enterprise Cloud Development",
            "description": "Building scalable and secure cloud-based solutions to support enterprise-level business needs."
          },
          {
            "@type": "Service",
            "name": "Cloud Integration",
            "description": "Integrating cloud technologies with your existing systems for streamlined workflows and improved data management."
          },
          {
            "@type": "Service",
            "name": "Cloud Optimization",
            "description": "Optimizing cloud environments for better performance, cost-efficiency, and scalability."
          },
          {
            "@type": "Service",
            "name": "Custom SaaS",
            "description": "Developing custom Software as a Service (SaaS) applications tailored to your business needs."
          },
          {
            "@type": "Service",
            "name": "SaaS for Startups",
            "description": "Providing SaaS solutions for startups to help them scale and optimize their business operations."
          },
          {
            "@type": "Service",
            "name": "SaaS for Enterprises",
            "description": "Enterprise-grade SaaS solutions designed to streamline complex business operations and increase productivity."
          },
          {
            "@type": "Service",
            "name": "Integration",
            "description": "Seamless integration of disparate systems and applications to ensure efficient workflows and data consistency."
          },
          {
            "@type": "Service",
            "name": "Optimization",
            "description": "Optimizing your software, processes, and infrastructure for maximum efficiency and performance."
          }
        ]
      }
      
    },
  },
  {
    path: "/oracle",
    component: Oracle,
    metaTag:{
      title:"Oracle Cloud",
      description:"Explore Oracle Cloud services including Upgrade, Managed Services, Support, ERP Cloud, HCM Cloud, OCI, Autonomous Database, Cloud Security & Migration solutions.",
      keyword:"Explore Oracle Cloud services: Managed services, support, OCI, Autonomous Database, ERP & HCM Cloud, cloud migration, pricing, security, and more.",
      canonical:false,
      // canonicalLink:"https://www.solverthoughts.com/products",
      ogTitle:"Oracle Cloud",
      ogDescription:"Explore Oracle Cloud services including Upgrade, Managed Services, Support, ERP Cloud, HCM Cloud, OCI, Autonomous Database, Cloud Security & Migration solutions.",
      ogUrl:"https://www.solverthoughts.com/oracle",
      ogImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      twitterCard:"summary_large_image",
      twitterTitle:"Oracle Cloud",
      twitterDescription:"SExplore Oracle Cloud services including Upgrade, Managed Services, Support, ERP Cloud, HCM Cloud, OCI, Autonomous Database, Cloud Security & Migration solutions.",
      twitterImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      script:true,
      scriptData:{
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": "Oracle Cloud Services",
        "provider": {
          "@type": "Organization",
          "name": "Solver Thoughts Technologies",
        },
        "description": "We provide a comprehensive range of Oracle Cloud services including Oracle Cloud Upgrade, Managed Services, Support, Report Writing, Configuration & Implementation. Specializing in Oracle Cloud Infrastructure (OCI), Oracle ERP Cloud, Oracle HCM Cloud, Oracle Autonomous Database, Cloud Security, Hybrid Cloud, and Cloud Migration for businesses across various industries.",
        "offers": [
          {
            "@type": "Offer",
            "name": "Oracle Cloud Upgrade",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "Oracle Cloud Managed Services",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "Oracle Support",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "Oracle Report Writing",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "Oracle Configuration & Implementation",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "Oracle Cloud Migration",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          }
        ]
      }
    
    },
  },
  {
    path: "/sharepoint",
    component: SharePoint,
    metaTag:{
      title:"Sharepoint Cloud",
      description:"Expert SharePoint customization, development, migration, and workflow automation services. Offering solutions for On-Premise & Online, document management, & more.",
      keyword:"Explore SharePoint services: online migration, document management, workflow automation, mobile access, customization, Microsoft 365 integration, and more.",
      canonical:false,
      // canonicalLink:"https://www.solverthoughts.com/products",
      ogTitle:"Sharepoint Cloud",
      ogDescription:"Expert SharePoint customization, development, migration, and workflow automation services. Offering solutions for On-Premise & Online, document management, & more.",
      ogUrl:"https://www.solverthoughts.com/sharepoint",
      ogImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      twitterCard:"summary_large_image",
      twitterTitle:"Sharepoint Cloud",
      twitterDescription:"Expert SharePoint customization, development, migration, and workflow automation services. Offering solutions for On-Premise & Online, document management, & more.",
      twitterImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      script:true,
      scriptData:{
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": "SharePoint Customization and Development Services",
        "provider": {
          "@type": "Organization",
          "name": "Solver Thoughts Technologies"
        },
        "description": "We provide comprehensive SharePoint On-Premise and Online services, including project management, document libraries, workflow automation, Power Automate development, Power BI dashboards, and seamless migration to SharePoint Online. Specializing in document management, versioning, metadata tagging, and collaboration tools.",
        "offers": [
          {
            "@type": "Offer",
            "name": "SharePoint On-Premise Customization",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint Online Development",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint Project Management",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint Library Management",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint Intranet Applications",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint Designer Workflows",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint Web-Part Development",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "Power Automate Development for SharePoint",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "Power BI Dashboards for SharePoint",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint Online Apps Development",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint Management",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint Migration Tool",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint Document Management System",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint for Collaboration",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "How to Migrate to SharePoint Online",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint Document Libraries",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint Document Versioning",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "Document Approval Workflow in SharePoint",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint File Sharing",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "How to Organize Documents in SharePoint",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint Metadata and Tagging",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint Document Management Best Practices",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "How to Manage Permissions in SharePoint",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint User Permissions",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint Security Best Practices",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint External Sharing",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint Access Control",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint Permission Levels Explained",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "How to Create Workflows in SharePoint",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "Automating Workflows with Power Automate in SharePoint",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint Workflow Automation",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "Create Custom Workflows in SharePoint",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "Automating Document Approval in SharePoint",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint Task Automation",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint Mobile App",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          },
          {
            "@type": "Offer",
            "name": "SharePoint Mobile Site Design",
            "priceCurrency": "USD",
            "price": "Contact for pricing",
            "eligibleRegion": "Global"
          }
        ]
      }
      
    },
  },
  {
    path: "/saleforce",
    component: Saleforce,
    metaTag:{
      title:"Salesforce Cloud",
      description:"SolverThoughts offers expert Salesforce services: Implementation, Customization, Integration, Support, Training, Analytics, and Marketing Cloud solutions.",
      keyword:"SolverThoughts offers expert Salesforce services: Implementation, Customization, Integration, Support, Training, Analytics, and Marketing Cloud solutions.",
      canonical:false,
      // canonicalLink:"https://www.solverthoughts.com/products",
      ogTitle:"Salesforce Cloud",
      ogDescription:"SolverThoughts offers expert Salesforce services: Implementation, Customization, Integration, Support, Training, Analytics, and Marketing Cloud solutions.",
      ogUrl:"https://www.solverthoughts.com/products/eam",
      ogImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      twitterCard:"summary_large_image",
      twitterTitle:"Salesforce Cloud",
      twitterDescription:"SolverThoughts offers expert Salesforce services: Implementation, Customization, Integration, Support, Training, Analytics, and Marketing Cloud solutions.",
      twitterImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      script:true,
      scriptData:{
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Solver Thoughts Technologies",
        "url": "https://www.solverthoughts.com",
        "description": "SolverThoughts offers expert Salesforce services: Implementation, Customization, Integration, Support, Training, Analytics, and Marketing Cloud solutions.",
        "serviceType": [
          {
            "@type": "Service",
            "name": "Salesforce Implementation",
            "description": "Salesforce implementation services to help businesses set up and optimize their Salesforce solutions."
          },
          {
            "@type": "Service",
            "name": "Salesforce Customization",
            "description": "Tailored Salesforce customization to meet your business needs and improve efficiency."
          },
          {
            "@type": "Service",
            "name": "Salesforce Integration",
            "description": "Integrate Salesforce with your existing systems for seamless data flow and operations."
          },
          {
            "@type": "Service",
            "name": "Salesforce Support and Maintenance",
            "description": "Ongoing Salesforce support and maintenance to ensure your system runs smoothly."
          },
          {
            "@type": "Service",
            "name": "Salesforce Training",
            "description": "Comprehensive Salesforce training to empower your team with essential skills and knowledge."
          },
          {
             "@type": "Service",
      "name": "Salesforce Analytics and Reporting",
      "description": "Powerful Salesforce analytics and reporting to drive data-informed decision-making."
    },
    {
      "@type": "Service",
      "name": "Salesforce Marketing Cloud",
      "description": "Maximize marketing efforts with Salesforce Marketing Cloud services for personalized customer engagement."
    }
  ]
}
    },
  },
  {
    path: "/cybersecurity",
    component: CyberSecurity,
    metaTag:{
      title:"Cyber Security Service",
      description:"SolverThoughts offers end-to-end cybersecurity services, including risk assessment, network security, cloud security, IAM, data protection, and more.",
      keyword:"Cybersecurity Services, Cybersecurity Risk Assessment, Managed Security Services, Network Security, Cloud Security, Endpoint Security, IAM, Data Protection, Encryption, Incident Response, Digital Forensics, Security Awareness Training",
      canonical:false,
      // canonicalLink:"https://www.solverthoughts.com/products",
      ogTitle:"Cyber Security Service",
      ogDescription:"SolverThoughts offers end-to-end cybersecurity services, including risk assessment, network security, cloud security, IAM, data protection, and more.",
      ogUrl:"https://www.solverthoughts.com/products/eam",
      ogImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      twitterCard:"summary_large_image",
      twitterTitle:"Cyber Security Service",
      twitterDescription:"SolverThoughts offers end-to-end cybersecurity services, including risk assessment, network security, cloud security, IAM, data protection, and more.",
      twitterImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      script:true,
      scriptData:{
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "SolverThoughts",
        "url": "https://www.solverthoughts.com",
        "description": "SolverThoughts offers end-to-end cybersecurity services, including risk assessment, network security, cloud security, IAM, data protection, and more.",
        "serviceType": [
          {
            "@type": "Service",
            "name": "Cybersecurity Risk Assessment & Gap Analysis",
            "description": "Identifying and analyzing cybersecurity risks and vulnerabilities within your organization's systems and networks."
          },
          {
            "@type": "Service",
            "name": "Managed Security Services (MSS)",
            "description": "Ongoing monitoring and management of your security infrastructure to ensure continuous protection against threats."
          },
          {
            "@type": "Service",
            "name": "Network and Infrastructure Security",
            "description": "Securing your network and IT infrastructure from potential threats and vulnerabilities to ensure smooth operations."
          },
          {
            "@type": "Service",
            "name": "Cloud Security Services",
            "description": "Providing comprehensive security solutions for your cloud-based environments, ensuring data and applications remain secure."
          },
          {
            "@type": "Service",
            "name": "Endpoint Security",
            "description": "Protecting endpoints, such as devices and workstations, from potential threats and malware."
          },
          {
            "@type": "Service",
            "name": "Identity and Access Management (IAM)",
            "description": "Ensuring the right individuals have appropriate access to the right resources while protecting sensitive information."
          },
          {
            "@type": "Service",
            "name": "Data Protection and Encryption",
            "description": "Securing sensitive data both in transit and at rest with encryption and advanced data protection strategies."
          },
          {
            "@type": "Service",
            "name": "Incident Response and Digital Forensics",
            "description": "Responding to security incidents quickly and investigating digital footprints to uncover potential breaches."
          },
          {
            "@type": "Service",
            "name": "Security Awareness & Training",
            "description": "Training employees on best practices and protocols to prevent security breaches and reduce human error in cybersecurity."
          }
        ]
      }
    },
  },
  {
    path: "/testautomation",
    component: TestAutomation,
    metaTag:{
      title:"Test Automation",
      description:"Solverthoughts: Expert QA & Test Automation including TestingWhiz. Ensure flawless software performance with Selenium, Playwright, Cypress, Katalon & more.",
      keyword:"software testing, QA services, test automation, Selenium testing, Playwright testing, Cypress testing, Katalon testing, TestingWhiz, performance testing, load testing, software quality assurance, automation testing services",
      canonical:false,
      // canonicalLink:"https://www.solverthoughts.com/products",
      ogTitle:"Test Automation",
      ogDescription:"Solverthoughts: Expert QA & Test Automation including TestingWhiz. Ensure flawless software performance with Selenium, Playwright, Cypress, Katalon & more.",
      ogUrl:"https://www.solverthoughts.com/testautomation",
      ogImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      twitterCard:"summary_large_image",
      twitterTitle:"Test Automation",
      twitterDescription:"Solverthoughts: Expert QA & Test Automation including TestingWhiz. Ensure flawless software performance with Selenium, Playwright, Cypress, Katalon & more.",
      twitterImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      script:true,
      scriptData:{
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Quality Assurance & Test Automation Services",
    "description": "Solverthoughts specializes in reliable and scalable software testing solutions, including automation and performance testing, to ensure robust and bug-free applications.",
    "serviceOffered": [
      {
        "@type": "Service",
        "name": "Quality Assurance (QA) Services"
      },
      {
        "@type": "Service",
        "name": "Test Automation Services",
        "additionalType": [
          "Selenium Testing",
          "Playwright Testing",
          "Cypress Testing",
          "Katalon Testing",
          "TestingWhiz",
          "Cross-browser Automation",
          "Web Application Testing Automation",
          "Mobile Application Testing Automation",
          "API Testing Automation",
          "End-to-End Testing Automation",
          "Test Automation Framework Development",
          "Automated Regression Testing"
        ]
      },
      {
        "@type": "Service",
        "name": "Performance Testing",
        "additionalType": [
          "Load Testing",
          "Stress Testing",
          "Scalability Testing",
          "Response Time Optimization",
          "Stability Testing"
        ]
      }
    ],
    "provider": {
      "@type": "Organization",
      "name": "Solverthoughts"
    }
  }
    }
  },
  {
    path: "/outsourcing",
    component: Outsourcing,
    metaTag:{
      title:"IT Outsourcing & Staff Augmentation | Solver Thoughts Technologies",
      description:"Scale your team with Solver Thoughts Technologies' offshore staff and team augmentation services — skilled developers in React, Angular, Node.js, PHP, DevOps, and more.",
      keyword:"IT outsourcing, offshore staff augmentation, offshore team augmentation, dedicated developers, remote development team, staff augmentation services",
      canonical:true,
      canonicalLink:"https://www.solverthoughts.com/outsourcing",
      ogTitle:"IT Outsourcing & Staff Augmentation | Solver Thoughts Technologies",
      ogDescription:"Scale your team with Solver Thoughts Technologies' offshore staff and team augmentation services — skilled developers across modern tech stacks.",
      ogUrl:"https://www.solverthoughts.com/outsourcing",
      ogImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      twitterCard:"summary_large_image",
      twitterTitle:"IT Outsourcing & Staff Augmentation | Solver Thoughts Technologies",
      twitterDescription:"Scale your team with Solver Thoughts Technologies' offshore staff and team augmentation services — skilled developers across modern tech stacks.",
      twitterImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      script:false,
    },
  },
  {
    path: "/hrdf",
    component: HDRF,
    metaTag:{
      title:"HRDF Training | Coaching, Mentoring & Training Programs | Solver Thoughts Technologies",
      description:"Solver Thoughts Technologies offers HRDF-claimable coaching, mentoring, and training programs to upskill your workforce and drive organizational growth.",
      keyword:"HRDF training, HRDF claimable courses, coaching, mentoring, corporate training Malaysia, workforce development",
      canonical:true,
      canonicalLink:"https://www.solverthoughts.com/hrdf",
      ogTitle:"HRDF Training | Solver Thoughts Technologies",
      ogDescription:"Solver Thoughts Technologies offers HRDF-claimable coaching, mentoring, and training programs to upskill your workforce.",
      ogUrl:"https://www.solverthoughts.com/hrdf",
      ogImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      twitterCard:"summary_large_image",
      twitterTitle:"HRDF Training | Solver Thoughts Technologies",
      twitterDescription:"Solver Thoughts Technologies offers HRDF-claimable coaching, mentoring, and training programs to upskill your workforce.",
      twitterImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      script:false,
    },
  },
  {
    path: "/faq",
    component: FAQ,
    metaTag:{
      title:"Frequently Asked Questions | Solver Thoughts Technologies",
      description:"Find answers to common questions about Solver Thoughts Technologies' products and services, including EAM, CMMS, outsourcing, and enterprise solutions.",
      keyword:"Solver Thoughts FAQ, frequently asked questions, EAM CMMS FAQ, enterprise software support",
      canonical:true,
      canonicalLink:"https://www.solverthoughts.com/faq",
      ogTitle:"Frequently Asked Questions | Solver Thoughts Technologies",
      ogDescription:"Find answers to common questions about Solver Thoughts Technologies' products and services, including EAM, CMMS, outsourcing, and enterprise solutions.",
      ogUrl:"https://www.solverthoughts.com/faq",
      ogImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      twitterCard:"summary_large_image",
      twitterTitle:"Frequently Asked Questions | Solver Thoughts Technologies",
      twitterDescription:"Find answers to common questions about Solver Thoughts Technologies' products and services, including EAM, CMMS, outsourcing, and enterprise solutions.",
      twitterImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      script:false,
    },
  },
  {
    path: "/contactus",
    component: ContactUs,
    metaTag:{
      title:"Contact Us | Solver Thoughts Technologies",
      description:"Get in touch with Solver Thoughts Technologies for EAM, CMMS, safety, outsourcing, and enterprise software inquiries. Based in Kuala Lumpur, Malaysia.",
      keyword:"Contact Solver Thoughts Technologies, EAM CMMS support, enterprise software company contact, Kuala Lumpur software company",
      canonical:true,
      canonicalLink:"https://www.solverthoughts.com/contactus",
      ogTitle:"Contact Us | Solver Thoughts Technologies",
      ogDescription:"Get in touch with Solver Thoughts Technologies for EAM, CMMS, safety, outsourcing, and enterprise software inquiries.",
      ogUrl:"https://www.solverthoughts.com/contactus",
      ogImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      twitterCard:"summary_large_image",
      twitterTitle:"Contact Us | Solver Thoughts Technologies",
      twitterDescription:"Get in touch with Solver Thoughts Technologies for EAM, CMMS, safety, outsourcing, and enterprise software inquiries.",
      twitterImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      script:false,
    },
  },
];

export const policyRouteLink=[
  {
    path: "/policy",
    component: PrivacyPolicy,
    metaTag:{
      title:"Privacy Policy | Solver Thoughts Technologies",
      description:"Read Solver Thoughts Technologies' Privacy Policy to understand how we collect, use, and protect your personal data.",
      keyword:"Solver Thoughts privacy policy, data protection, personal data policy",
      canonical:true,
      canonicalLink:"https://www.solverthoughts.com/policy",
      ogTitle:"Privacy Policy | Solver Thoughts Technologies",
      ogDescription:"Read Solver Thoughts Technologies' Privacy Policy to understand how we collect, use, and protect your personal data.",
      ogUrl:"https://www.solverthoughts.com/policy",
      ogImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      twitterCard:"summary_large_image",
      twitterTitle:"Privacy Policy | Solver Thoughts Technologies",
      twitterDescription:"Read Solver Thoughts Technologies' Privacy Policy to understand how we collect, use, and protect your personal data.",
      twitterImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      script:false,
    },
  },
  {
    path: "/terms",
    component: Terms,
    metaTag:{
      title:"Terms and Conditions | Solver Thoughts Technologies",
      description:"Review the Terms and Conditions governing the use of Solver Thoughts Technologies' website, products, and services.",
      keyword:"Solver Thoughts terms and conditions, terms of use, service agreement",
      canonical:true,
      canonicalLink:"https://www.solverthoughts.com/terms",
      ogTitle:"Terms and Conditions | Solver Thoughts Technologies",
      ogDescription:"Review the Terms and Conditions governing the use of Solver Thoughts Technologies' website, products, and services.",
      ogUrl:"https://www.solverthoughts.com/terms",
      ogImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      twitterCard:"summary_large_image",
      twitterTitle:"Terms and Conditions | Solver Thoughts Technologies",
      twitterDescription:"Review the Terms and Conditions governing the use of Solver Thoughts Technologies' website, products, and services.",
      twitterImage:"https://www.solverthoughts.com/Images/s2tlogo.png",
      script:false,
    },
  },
]
